import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=0b746c64&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=0b746c64&prod&scoped=true&lang=css"
import style1 from "./SendEmail.vue?vue&type=style&index=1&id=0b746c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b746c64",
  null
  
)

export default component.exports